import useSWR from "swr";
import api from "@/lib/api";

const fetcher = (url) => api.get(url).then((r) => r.data);
const withParams = (url, params) => {
  if (!params) return url;
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();
  return qs ? `${url}?${qs}` : url;
};

export const useSettings = () =>
  useSWR("/settings", fetcher, {
    fallbackData: {
      company_name: "Orvella Overseas Private Limited",
      tagline: "Connecting Global Opportunities",
      whatsapp: "+91 99735 19755",
      phone: "+91 99735 19755",
      email: "info@orvellaoverseas.com",
      address: "Western Mall 606, RPS More, Bailey Road, Patna 801503, Bihar, India",
      key_person_name: "Dhiraj Kumar",
      key_person_title: "[TO BE UPDATED]",
      key_person_phone: "+91 91993 19199",
      key_person_photo: "",
      logo_url: "",
      social: {},
      analytics: {},
      catalogue_url: "",
      catalogue_requires_info: true,
      markets: [],
    },
  });

export const useCategories = () => useSWR("/categories", fetcher, { fallbackData: [] });
export const useProducts = (params) => useSWR(withParams("/products", params), fetcher, { fallbackData: [] });
export const useProduct = (slug) => useSWR(slug ? `/products/${slug}` : null, fetcher);
export const useFaqs = () => useSWR("/faqs", fetcher, { fallbackData: [] });
export const usePosts = (category) => useSWR(withParams("/posts", { category }), fetcher, { fallbackData: [] });
export const usePost = (slug) => useSWR(slug ? `/posts/${slug}` : null, fetcher);
export const useCertificates = () => useSWR("/certificates", fetcher, { fallbackData: [] });
export const useTestimonials = () => useSWR("/testimonials", fetcher, { fallbackData: [] });
export const useDocuments = () => useSWR("/documents", fetcher, { fallbackData: [] });
